(function ($) {

    /**
     * Product slider
     **/
    var $slider = $('.js-products-slider-header'),
        $prev = $('.js-products-header-prev'),
        $next = $('.js-products-header-next')
    
    /**
     * Init slick
     **/
    $slider.each(function() {
        $(this).slick({
            dots: false,
            arrows: true,
            prevArrow: '<button class="slider__arrow-header slider__arrow--prev slider-arrow products-slider__arrow"><i class="icon icon-arrow-prev"></i></button>',
            nextArrow: '<button class="slider__arrow-header slider__arrow--next slider-arrow products-slider__arrow"><i class="icon icon-arrow-next"></i></button>',
            appendArrows: $(this).attr('data-arrow-target'),
            infinite: true,
            autoplay: false,
            autoplaySpeed: 4000,
            speed: 300,
            rows: 0,
            slidesToShow: 1,
            slidesToScroll: 1,
            responsive: [
                {
                    breakpoint: 991,
                    settings: {
                        slidesToShow: 2,
                    }
                },
                {
                    breakpoint: 550,
                    settings: {
                        slidesToShow: 1,
                    }
                },
            ]
        });
    })

    /**
     * Arorws
     **/
    $next.on('click', function() {
        var target = $(this).attr('data-target')
        $(target).slick('slickNext');
    });

    $prev.on('click', function() {
        var target = $(this).attr('data-target')
        $(target).slick('slickPrev');
    });
    
})(jQuery);
				
